
import Vue from "vue";
import { mgr } from "@/managers";
import { iTicket } from "@/managers/tickets";
import { iSopStep } from "@/managers/sop";
import { ActionType } from "@/managers/ticketActions";

export default Vue.extend({
  name: "CheckVideo",
  components: {},
  props: {
    step: { type: Object as () => iSopStep, required: true },
    ticket: { type: Object as () => iTicket, required: true },
  },
  data: () => ({}),
  computed: {
    actionTypes(): ActionType[] {
      return this.ticket.actions.map((x) => x.actionType);
    },
    isResolved(): boolean {
      return this.actionTypes.includes(ActionType.TRACKING_VIEWED);
    },
    displayText(): string {
      if (this.ticket.alertType == "SPEEDING" || this.ticket.alertType == "MOUNTAIN_PASS_SPEEDING")
        return "I have checked the speed at the time of the event";
      return "I have viewed tracking sites";
    },
  },
  methods: {
    resolve() {
      if (this.isResolved) return;
      mgr.ticketActions.trackingViewed(this.ticket.id);
    },
    updateStep() {
      if (this.isResolved) {
        this.$emit("updateStep", { step: this.step, resolved: true });
      } else {
        this.$emit("updateStep", {
          step: this.step,
          resolved: false,
          unResolvedReason: "Tracking sites not yet viewed",
        });
      }
    },
  },
  watch: {
    actionTypes() {
      this.updateStep();
    },
  },
  mounted() {
    this.updateStep();
  },
});
